import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithRefresh} from "@/lib/api/utils";
import {ApiTagsEnum} from "@/lib/enums/ApiTagsEnum";

export const api = createApi({
    reducerPath: "gamesApi",
    baseQuery: baseQueryWithRefresh(ApiTagsEnum.GAMES),
    tagTypes: ['FavouriteGames'],
    endpoints: () => ({}),
})
